import http from '@core/fetch'
export default {
  //菜单列表
  menulist: params =>
    http('/p/wedding/index.php/admin/APIHotelMerchant/menu_list', {
      body: params
    }),

  //菜单上下架
  menufromsale: params =>
    http.post('/p/wedding/index.php/admin/APIHotelMerchant/menu_status', {
      body: params
    }),

  //场地列表
  sitelist: params =>
    http('/p/wedding/index.php/admin/APIHotelMerchant/hall_list', {
      body: params
    }),

  //场地上下架
  sitefromsale: params =>
    http.post('/p/wedding/index.php/admin/APIHotelMerchant/hall_status', {
      body: params
    }),

  // 上传酒店场地竖图
  uploadVerticalImg: params =>
    http.post('/p/wedding/index.php/admin/APIHotelMerchant/verticalCoverUrl', {
      body: params
    }),

  // 检测是否需要竖图弹窗
  isEditVerticalImage: params =>
    http('/p/wedding/index.php/Admin/APIMerchant/isEditVerticalImage', {
      body: params
    }),
  // 检测是否绑定套餐
  mealCheckByMenulId: params =>
    http('/p/wedding/index.php/admin/APIHotelMerchant/MealCheckByMenulId', {
      body: params
    }),
  // 检测是否需要补全场地信息
  isSiteNeedCompleteInfo: () =>
    http('/p/wedding/index.php/admin/APIHotelMerchant/hallNotify'),
  // 获取审核未通过的数量, type-> 1:场地 2: 菜单
  getUnAuditNumber: type =>
    http('/hms/hljHotel/appApi/admin/hotelManage/materialStatusCount', {
      body: { type }
    })
  //菜单列表
  // menulist:async (params)=>{
  //     try {
  //         let res= await fetch('/p/wedding/index.php/admin/APIHotelMerchant/menu_list?'+params,{
  //             method:'get',
  //             headers: {
  //                 'Accept': 'application/json',
  //                 'Content-Type': 'application/json',
  //                 "HUNLIJI_MERCHANT_AUTH":'328578%2C1482139890%2Cade47abd85deeb896eb1c2089e84a371'
  //             },
  //             credentials:'include'
  //         });
  //         return res.json();
  //     }catch(err){
  //         console.log(err)
  //     }
  // },
  //菜单上下架
  // menufromsale: async params=>{
  //     try {
  //         let res= await fetch('/p/wedding/index.php/admin/APIHotelMerchant/menu_status',{
  //             method:'post',
  //             headers: {
  //                 'Accept': 'application/json',
  //                 'Content-Type': 'application/json',
  //                 "HUNLIJI_MERCHANT_AUTH":'328578%2C1482139890%2Cade47abd85deeb896eb1c2089e84a371'
  //             },
  //             credentials:'include',
  //             body:JSON.stringify(params)
  //         });
  //         return res
  //     }catch(err){
  //         console.log(err)
  //     }
  // },
  //场地列表
  // sitelist:async (params)=>{
  //     try {
  //         let res= await fetch('/p/wedding/index.php/admin/APIHotelMerchant/hall_list?'+params,{
  //             method:'get',
  //             headers: {
  //                 'Accept': 'application/json',
  //                 'Content-Type': 'application/json',
  //                 "HUNLIJI_MERCHANT_AUTH":'328578%2C1482139890%2Cade47abd85deeb896eb1c2089e84a371'
  //             },
  //             credentials:'include'
  //         });
  //         return res.json();
  //     }catch(err){
  //         console.log(err)
  //     }
  // },
  //场地上下架
  // sitefromsale: async params=>{
  //     try {
  //         let res= await fetch('/p/wedding/index.php/admin/APIHotelMerchant/hall_status',{
  //             method:'post',
  //             headers: {
  //                 'Accept': 'application/json',
  //                 'Content-Type': 'application/json',
  //                 "HUNLIJI_MERCHANT_AUTH":'328578%2C1482139890%2Cade47abd85deeb896eb1c2089e84a371'
  //             },
  //             credentials:'include',
  //             body:JSON.stringify(params)
  //         });
  //         return res
  //     }catch(err){
  //         console.log(err)
  //     }
  // }
}
